import React from 'react';
import { Flex } from 'grid-styled';
import Updater from './Updater';
import session from '../session';

import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';
import Button from '../uic/Button';

export default class Upload extends React.Component {
    state = {
        uploadinprogress: false,
        fileuploaded: ''
    };

    onUpload = async () => {
        this.setState({ uploadinprogress: !this.state.uploadinprogress });
        const { onDone } = this.props;

        const data = new FormData();
        const imagedata = document.querySelector('input[type="file"]').files[0];

        data.append('instreamer4', imagedata);

        try {
            await session.realm.fetch(this.props.urllink, {
                method: 'POST',
                body: data
            });

            if (onDone) {
                onDone();
            }
        } catch (err) {
            console.error('Failed to import configuration', err);
        }
    };

    render() {
        return (
            <div>
                {this.props.streamimport ? (
                    <div>
                        <BoxTemplate height="30px" />
                        <BoxTemplate mt={'20px'} mb={'20px'} textalign="left">
                            {this.state.uploadinprogress ? (
                                <Label textStyle="labelNormal">
                                    Uploading file, please wait...
                                </Label>
                            ) : (
                                <input id="filename" type="file" name="file" />
                            )}
                        </BoxTemplate>
                        {!this.state.uploadinprogress && (
                            <Flex justifyContent="flex-end">
                                <Button
                                    buttonStyle="primary"
                                    onClick={this.onUpload}
                                    icon="cloud_upload"
                                >
                                    Upload
                                </Button>
                            </Flex>
                        )}
                    </div>
                ) : (
                    <Updater urllink={this.props.urllink} />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/uic/Upload.js